import StudentAPI from "../apis/StudentAPI";
import store from "../store";
import AlertService from "./AlertService";
import {
  SET_STUDENT_ACCOUNTS,
  RESET_STUDENT,
  FETCH_INTERVIEW_LINKS,
  FETCH_INTERVIEW_LINKS_ALL,
} from "../actions/types";

class StudentService {
  async GetStudentByID(id) {
    // DEPRECATED
    // TODO, remove any locations getting student by id
    try {
      const resp = await StudentAPI.get("student/" + id);
      return resp.data;
    } catch (err) {}
  }

  async getAllStudents() {
    try {
      const resp = await StudentAPI.get("student/");
      return resp.data;
    } catch (error) {}
  }

  async getStudent(uuid) {
    try {
      const resp = await StudentAPI.get(
        "student/getStudent/" + uuid
      );
      return resp.data;
    } catch (err) {}
  }

  async getManyStudent(idList) {
    try {
      const resp = await StudentAPI.post("student/getManyStudent/", idList);
      return resp.data;
    } catch (err) {
    }
  }

  async getManyStudentAccountByStudentID(idList) {
    try {
      const resp = await StudentAPI.post(
        "studentAccount/getManyStudentAccount/",
        idList
      );
      return resp.data;
    } catch (err) {
    }
  }

  async getStudentAlerts(uuid) {
    try {
      // Entity type: 1 signifies we are looking for alerts attached to a student
      const resp = await StudentAPI.post(`alert/search/${uuid}`, {
        EntityType: 1,
      });
      return resp.data;
    } catch (err) {}
  }

  async addStudentAlert(uuid, alert) {
    try {
      // Entity type: 1 signifies we are looking for alerts attached to a student
      const resp = await StudentAPI.post(`alert/add/${uuid}`, {
        ...alert,
        EntityType: 1,
      });
      AlertService.addSuccessAlert("Alert Added");
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert("Alert could not be added");
    }
  }

  async getStudentMemos(uuid) {
    try {
      // Entity type: 1 signifies we are looking for memos attached to a student
      const resp = await StudentAPI.post(`memo/search/${uuid}`, {
        EntityType: 1,
      });
      return resp.data;
    } catch (err) {}
  }

  async addStudentMemo(uuid, memo) {
    try {
      // Entity type: 1 signifies we are looking for alerts attached to a student
      const resp = await StudentAPI.post(`memo/add/${uuid}`, {
        ...memo,
        EntityType: 1,
      });
      AlertService.addSuccessAlert("Memo Added");
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert("Memo could not be added");
    }
  }

  async deleteReminder(id) {
    try {
      // Entity type: 1 signifies we are looking for alerts attached to a student
      const resp = await StudentAPI.delete(`reminder/${id}`);
      AlertService.addSuccessAlert("Item was deleted");
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert("Item could not be deleted");
    }
  }

  async updateAlert(id, alert) {
    try {
      // Entity type: 1 signifies we are looking for alerts attached to a student
      const resp = await StudentAPI.patch(`alert/${id}`, alert);
      AlertService.addSuccessAlert("Item was updated");
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert("Item could not be updated");
    }
  }

  async updateReminder(id, reminder) {
    try {
      // Entity type: 1 signifies we are looking for alerts attached to a student
      const resp = await StudentAPI.patch(`reminder/${id}`, reminder);
      AlertService.addSuccessAlert("Item was updated");
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert("Item could not be updated");
    }
  }

  async expireReminder(id) {
    try {
      // Entity type: 1 signifies we are looking for alerts attached to a student
      const resp = await StudentAPI.patch(`reminder/expire/${id}`, null);
      AlertService.addSuccessAlert("Item was expired");
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert("Item could not be expired");
    }
  }

  async getStudentQuickView(uuid, aidYear) {
    try {
      const resp = await StudentAPI.get(
        "student/getStudentQuickView/" + uuid + "/" + aidYear
      );
      return resp.data;
    } catch (err) {}
  }

  async createAccount(account, isAdmin) {
    try {
      const resp = await StudentAPI.post("accountCreationService/", account);
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert(err.response.data);
    }
  }

  async updateStudentProfile(
    parameters,
    retainedAccount,
    accountType,
    accountLink,
    retainedAccountLink
  ) {
    try {
      const resp = await StudentAPI.post(
        "studentAccountService/updateStudentProfile/",
        { aidYear: store.getState().global.aidYear, ...parameters }
      );

      if (resp.message) {
        AlertService.addErrorAlert(resp.message);
      } else {
        if (resp.data.studentAccount) {
          var payloadToUpdate;

          if (accountType === 0) {
            payloadToUpdate = {
              studentAccount: resp.data.studentAccount,
              parentAccount: retainedAccount,
              studentAccountLink: resp.data.studentAccountLink
                ? resp.data.studentAccountLink
                : accountLink,
              parentAccountLink: retainedAccountLink,
            };
          } else {
            payloadToUpdate = {
              studentAccount: retainedAccount,
              parentAccount: resp.data.studentAccount,
              studentAccountLink: retainedAccountLink,
              parentAccountLink: resp.data.studentAccountLink
                ? resp.data.studentAccountLink
                : accountLink,
            };
          }

          store.dispatch({
            type: SET_STUDENT_ACCOUNTS,
            payload: payloadToUpdate,
          });
        }
      }

      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert(err.response.data);
    }
  }

  async studentSearch(searchParameters) {
    try {
      const resp = await StudentAPI.post("student/userSearch/false", {
        aidYear: parseInt(store.getState().global.aidYear),
        ...searchParameters,
      });
      return resp.data;
    } catch (err) {
    }
  }

  async studentLookup(searchParameters) {
    try {
      const response = await StudentAPI.post(
        "/student/studentLookup",
        searchParameters
      );
      return response.data;
    } catch (err) {
    }
  }

  async studentLookupLinked(searchParameters) {
    try {
      const response = await StudentAPI.post(
        "/student/studentLookupLinked",
        searchParameters
      );
      return response.data;
    } catch (err) {
    }
  }

  async addParentStudentLink(addParentStudentLinkDto) {
    try {
      const response = await StudentAPI.post(
        "/student/AddParentStudentLink",
        addParentStudentLinkDto
      );
      return response.data;
    } catch (err) {
    }
  }

  async linkStudentToAccount(
    studentID,
    studentAccountID,
    eSignOptOut,
    eSignOptOutDate,
    accountType
  ) {
    try {
      const resp = await StudentAPI.post("studentAccountLink/", {
        studentID: studentID,
        studentAccountID: studentAccountID,
        eSignOptOut: eSignOptOut,
        eSignOptOutDate: eSignOptOutDate,
        accountType: accountType,
      });

      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert("Linking failed");
      return false;
    }
  }

  async createInitialTasksAndMessage(studentID, studentAccountID) {
    try {
      const resp = await StudentAPI.post(
        "accountCreationService/createInitialTasksAndMessage",
        {
          studentID: studentID,
          studentAccountID: studentAccountID,
        }
      );

      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert(err.response.data);
    }
  }

  async studentAccountSearch(studentID, accountType) {
    try {
      const studentIDs = [studentID];
      const resp = await StudentAPI.post(
        "studentAccount/getManyStudentAccount",
        studentIDs
      );
      let accountLinks = (await this.searchStudentAccountLinks(
        { studentID: studentID })).data ?? [];
      accountLinks = accountLinks.filter(
        x => x.accountType === accountType);
      const filteredResp = resp.data.filter(
        x => accountLinks.map(l => l.studentAccountID).includes(x.id));
      return filteredResp.length !== 0 ? filteredResp : null;
    } catch (err) {
    }
  }

  async getStudentAccountsByStudentID(studentID) {
    try {
      const studentIDs = [studentID];
      const resp = await StudentAPI.post(
        "studentAccount/getManyStudentAccount",
        studentIDs
      );
      return resp.data;
    } catch (err) {
    }
  }

  async getStudentsByStudentAccountID(studentAccountID) {
    try {
      const studentAccountIDs = [studentAccountID];
      const resp = await StudentAPI.post(
        "student/getManyStudentByStudentAccountIDs",
        studentAccountIDs
      );
      return resp.data;
    } catch (err) {
    }
  }

  async getStudentAccountsByUUID(uuid) {
    try {
      const resp = await StudentAPI.get(
        `studentAccount/getStudentAccountsByUUID/${uuid}`
      );
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert("Account Lookup Failed")
    }
  }

  async addAccountPasswordReset(searchParameters) {
    try {
      searchParameters.aidYear = store.getState().global.aidYear;
      const resp = await StudentAPI.post(
        "studentAccountService/AddAccountPasswordReset",
        {
          ...searchParameters,
        }
      );
      return resp.data;
    } catch (err) {
    }
  }

  async createSMSToken(uuid, username, schoolCode) {
    try {
      const resp = await StudentAPI.post(
        "studentAccountService/CreateSMSToken",
        {
          studentUuid: uuid,
          username: username,
          schoolCode: await schoolCode,
        }
      );

      AlertService.addSuccessAlert(resp.data);

      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert(err.response.data);
    }
  }

  async verifySMSToken(uuid, smsToken, username) {
    try {
      const resp = await StudentAPI.post(
        "studentAccountService/verifySMSToken",
        {
          studentUuid: uuid,
          smsToken: smsToken,
          username: username,
        }
      );

      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert(err.response.data);
       // eslint-disable-next-line
      throw "";
    }
  }

  async SendResetPasswordEmail(uuid, username, schoolCode, locationHREF) {
    try {
      const resp = await StudentAPI.post(
        "studentAccountService/SendResetPasswordEmail",
        {
          studentUuid: uuid,
          aidYear: store.getState().global.aidYear,
          username: username,
          schoolCode: await schoolCode,
          locationHREF: locationHREF,
        }
      );

      AlertService.addSuccessAlert(resp.data);

      return resp.data;
    } catch (err) {
      let errorMessage = err.response.data;
      if (errorMessage === "Issue sending email to your inbox") {
        AlertService.addErrorAlert(errorMessage)
      } else {
        AlertService.addErrorAlert("Reset email failed");
      }
      return false;
    }
  }

  async SendSmsConfirmation(phoneNumber, schoolCode, studentID, uuid) {
    try {
      const resp = await StudentAPI.post(
        "studentAccountService/SendSmsConfirmation/",
        {
          phoneNumber: phoneNumber,
          schoolCode: schoolCode,
          studentID: studentID,
          studentUuid: uuid
        }
      );
      AlertService.addSuccessAlert(resp.data);
      return resp.status;
    } catch (err) {
      AlertService.addErrorAlert(
        "Something went wrong sending the confirmation"
      );
    }
  }

  async verifySecurityQuestion(securityQuestionLinkID, answer) {
    try {
      const resp = await StudentAPI.post("securityQuestionLink/verifyAnswer", {
        id: securityQuestionLinkID,
        answer: answer,
      });
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert("Answer is incorrect!");
    }
  }

  async securityQuestionGetAll() {
    try {
      const resp = await StudentAPI.get("securityQuestion/");
      return resp.data;
    } catch (err) {
    }
  }

  async GetAccountSecurityQuestions(studentUuid, username) {
    try {
      var parameters = {
        studentUuid: studentUuid,
        username: username,
      };
      const resp = await StudentAPI.post(
        "studentAccountService/getAccountSecurityQuestions",
        parameters
      );
      return resp.data;
    } catch (err) {
    }
  }

  async updateAccountSecurityQuestions(
    studentUuid,
    accountType,
    securityQuestionLinks
  ) {
    try {
      var parameters = {
        studentUuid: studentUuid,
        accountType: accountType,
        securityQuestionLinks: securityQuestionLinks,
      };
      const resp = await StudentAPI.post(
        "studentAccountService/updateAccountSecurityQuestions",
        parameters
      );
      return resp.data;
    } catch (err) {
    }
  }

  async taskListSearch(searchParameters) {
    try {
      const resp = await StudentAPI.post(
        "studentInterviewLink/taskListSearch",
        {
          ...searchParameters,
        }
      );
      return resp.data;
    } catch (err) {
      return null;
    }
  }

  async resetInterviewLinks() {
    var interviewLinksAll = await this.taskListSearch({
      studentID: store.getState().student.student.id,
      aidYear: store.getState().global?.aidYear
    });
    const interviewLinks = interviewLinksAll.filter(
      (x) =>
        x.studentInterviewLinkStatus !== "NOT_REQUIRED" &&
        x.studentInterviewLinkStatus !== "AUTO_VERIFIED"
    );
    store.dispatch({
      type: FETCH_INTERVIEW_LINKS,
      payload: interviewLinks,
    });
    store.dispatch({
      type: FETCH_INTERVIEW_LINKS_ALL,
      payload: interviewLinksAll,
    });
  }

  async updateStudentInterviewLink(searchParameters) {
    try {
      const resp = await StudentAPI.post(
        "studentInterviewLink/updateStudentInterviewLink",
        {
          ...searchParameters,
        }
      );
      return resp.data;
    } catch (err) {
      return false;
    }
  }

  async getStudentAttribute(studentId, aidYear) {
    try {
      const pathAidYear =
        aidYear !== undefined ? aidYear : store.getState().global.aidYear;
      const resp = await StudentAPI.get(
        "StudentAttribute/getStudentAttribute/" + studentId + "/" + pathAidYear
      );
      return resp.data;
    } catch (err) {
    }
  }

  async getParentProfile(studentId, aidYear) {
    try {
      const pathAidYear =
        aidYear !== undefined ? aidYear : store.getState().global.aidYear;
      const resp = await StudentAPI.get(
        "StudentAttribute/getParentProfile/" + studentId + "/" + pathAidYear
      );
      return resp.data;
    } catch (err) {
    }
  }

  async searchStudentAttribute(studentAttribute) {
    try {
      var aidYear = store.getState().global.aidYear;
      const resp = await StudentAPI.post(
        `StudentAttribute/search/${aidYear}`,
        studentAttribute
      );
      return resp.data;
    } catch (err) {
    }
  }

  async searchStudentAttributeHistory(studentAttribute) {
    try {
      var aidYear = store.getState().global.aidYear;
      const resp = await StudentAPI.post(
        `StudentAttributeHistory/search/${aidYear}`,
        studentAttribute
      );
      return resp.data;
    } catch (err) {
    }
  }

  //Verification Controller endpoint methods
  async getStudentVerifyData(studentAccountId, studentId) {
    try {
      const resp = await StudentAPI.get(
        "verification/getVerificationState/" +
          studentAccountId +
          "/" +
          studentId
      );
      return resp.data;
    } catch (err) {
    }
  }

  async getCorrectionSummaries(studentId) {
    try {
      const resp = await StudentAPI.get(
        "verification/getCorrectionSummaries/" + studentId
      );
      return resp.data;
    } catch (err) {
    }
  }

  async exportCorrections() {
    try {
      const resp = await StudentAPI.post("correction/ExportCorrections/");
      return resp.data;
    } catch (err) {
    }
  }

  async exportCorrectionsBySchoolCode(schoolCode, aidYear) {
    try {
      const resp = await StudentAPI.post(
        "correction/ExportCorrections/" + schoolCode + "/" + aidYear
      );
      return resp.data;
    } catch (err) {
    }
  }

  async exportDownloadCorrectionsBySchoolCode(schoolCode, aidYear) {
    try {
      const resp = await StudentAPI.post(
        "correction/ExportDownloadCorrections/" + schoolCode + "/" + aidYear
      );
      return resp.data;
    } catch (err) {
    }
  }

  async downloadCorrectionFile(schoolCode, fileName) {
    try {
      const resp = await StudentAPI.get(
        "correction/DownloadCorrectionFile/" + schoolCode + "/" + fileName
      );
      return resp.data;
    } catch (err) {
    }
  }

  async getBioInfo(studentAccountId, studentId) {
    try {
      const resp = await StudentAPI.get(
        "verification/getBiographicalInformation/" +
          studentAccountId +
          "/" +
          studentId
      );
      return resp.data;
    } catch (err) {
    }
  }

  setStudentAccounts = async (studentAccounts, studentID) => {
    let studentAccount = null;
    let parentAccount = null;
    let otherParentAccount = null;
    let spouseAccount = null;
    let studentAccountLink = null;
    let parentAccountLink = null;
    let otherParentAccountLink = null;
    let spouseAccountLink = null;
    if (studentAccounts !== "") {
      let accountLinks = await this.getManyStudentAccountLink({
        studentIDs: [studentID],
        studentAccountIDs: null,
      });
      studentAccounts.forEach(async (n) => {
        let accountLink = accountLinks.filter(x => x.studentAccountID === n.id)[0];
        if (accountLink.accountType === 0) {
          studentAccount = n;
          studentAccountLink = accountLink;
        } else if (accountLink.accountType === 1) {
          parentAccount = n;
          parentAccountLink = accountLink;
        } else if (accountLink.accountType === 3) {
          otherParentAccount = n;
          otherParentAccountLink = accountLink;
        } else if (accountLink.accountType === 4) {
          spouseAccount = n;
          spouseAccountLink = accountLink;
        }
      });
    }

    // Dispatch a synchronous redux action
    store.dispatch({
      type: SET_STUDENT_ACCOUNTS,
      payload: {
        studentAccount: studentAccount,
        parentAccount: parentAccount,
        otherParentAccount: otherParentAccount,
        spouseAccount: spouseAccount,  
        studentAccountLink: studentAccountLink,
        parentAccountLink: parentAccountLink,
        otherParentAccountLink: otherParentAccountLink,
        spouseAccountLink: spouseAccountLink
        },
    });

    return (studentAccount && studentAccount.id) ?? null;
  };

  resetStudent = () => {
    store.dispatch({
      type: RESET_STUDENT,
      payload: {},
    });
  };

  async getDefaultHousehold(studentID) {
    try {
      const resp = await StudentAPI.get(
        `student/GetDefaultHousehold/${studentID}`
      );
      return resp.data;
    } catch (err) {
    }
  }

  async getSignatureStatus(uuid, isForParent) {
    try {
      const resp = await StudentAPI.get(
        "student/GetSignatureStatus/" + uuid + "/" + isForParent
      );
      return resp.data;
    } catch (err) {
    }
  }

  async clearSignature(uuid, isForParent) {
    try {
      const resp = await StudentAPI.get(
        "student/ClearSignature/" + uuid + "/" + isForParent
      );
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert(`Signature clearing failed for ${isForParent ? "parent" : "student"}`);
      return false;
    }
  }

  async updateEsignOptOut(uuid, isForParent) {
    try {
      const resp = await StudentAPI.post(
        "student/updateEsignOptOut/" + uuid + "/" + isForParent
      );
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert("E-sign opt in failed");
      return false;
    }
  }

  async changeStudentStatus(studentID, status) {
    try {
      const resp = await StudentAPI.post(
        "student/changeStudentStatus/" + studentID + "/" + status
      );
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert("Status update failed");
      return false;
    }
  }

  async purgeParentAccount(parentAccountID, studentID) {
    try {
      const resp = await StudentAPI.post(
        "studentAccountService/purgeParentAccount/",
        {
          parentAccountID: parentAccountID,
          studentID: studentID,
        }
      );
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert("Unlink account failed");
      return false;
    }
  }

  async createBinder(uuid, inkSign, isForParentAccount) {
    try {
      var parameters = {
        uuid: uuid,
        inkSign: inkSign,
        isForParentAccount: isForParentAccount
      };

      const resp = await StudentAPI.post(`student/createBinder/`, parameters);
      return resp.data;
    } catch (err) {
    }
  }

  async getBinder(uuid, isForParentAccount) {
    try {
      const resp = await StudentAPI.get(
        "student/getBinder/" + uuid + "/" + isForParentAccount
      );
      return resp.data;
    } catch (err) {
    }
  }

  async getAllProcessorDocuments(studentID) {
    try {
      const resp = await StudentAPI.get(
        "processorDocument/getAllProcessorDocuments/" + studentID
      );
      return resp.data;
    } catch (err) {
    }
  }

  async deleteProcessorDocuments(alfrescoID) {
    try {
      const resp = await StudentAPI.delete(
        "processorDocument/deleteProcessorDocument/" + alfrescoID
      );
      return resp.data;
    } catch (err) {
    }
  }

  async getAllStudentInterviewLinkSupportingDocuments(studentID) {
    try {
      const resp = await StudentAPI.get(
        "studentInterviewLinkSupportingDocument/getAllStudentInterviewLinkSupportingDocuments/" +
          studentID
      );
      return resp.data;
    } catch (err) {
    }
  }

  async downloadProcessorBinder(UUID, createNewProcessorBinder = false) {
    try {
      const resp = await StudentAPI.get("student/getProcessorBinder/" + UUID + "/" + createNewProcessorBinder);
      return resp.data;
    } catch (err) {
    }
  }

  async createSuperBinder(UUID) {
    try {
      const resp = await StudentAPI.get("student/createSuperBinder/" + UUID);
      AlertService.addSuccessAlert("Super Binder has been created");
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert("Creating Super Binder failed");
      return false;
    }
  }

  async createSignaturePage(uuid, isForParent) {
    try {
      const resp = await StudentAPI.get(
        "student/createSignaturePage/" + uuid + "/" + isForParent
      );
      return resp.data;
    } catch (err) {
    }
  }

  // This method is called then the student agrees/commits to the ink sign process
  async inkSignAgreed(uuid, isForParent) {
    try {
      const resp = await StudentAPI.patch(
        "student/inkSignAgreed/" + uuid + "/" + isForParent
      );
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert("Update failed");
      return false;
    }
  }

  // this method is called when Inceptia (or the school) confirms receipt of the accounts signed documents
  // Returns true if the student is set to review (this happens if all required signatures are present and accounted for)
  async inkSignatureReceived(uuid, isForParent) {
    try {
      const resp = await StudentAPI.post(
        `student/inkSignatureReceived/${uuid}/${isForParent}`
      );
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert("Ink sign failed");
      return null;
    }
  }

  async eSign(uuid, isForParent) {
    try {
      const resp = await StudentAPI.post(
        "student/eSign/" + uuid + "/" + isForParent
      );
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert("E-sign failed");
      return null;
    }
  }

  async updateStudent(id, studentValues) {
    try {
      await StudentAPI.patch(`student/allowNullUpdate/${id}`, studentValues);
      return true;
    } catch (err) {
      AlertService.addErrorAlert("Update failed");
      return false;
    }
  }

  async updateStudentAccount(id, studentAccountValues) {
    try {
      await StudentAPI.patch(`studentAccount/${id}`, studentAccountValues);
    } catch (err) {
      return false;
    }
  }

  async updateStudentVerificationGroup(id, verificationGroup) {
    try {
      const resp = await StudentAPI.post(`student/updateStudentVerificationGroup/${id}/${verificationGroup}`);
      if(!resp.data){
        AlertService.addErrorAlert("Unable to assign student");
        return false;
      } else {
        return resp.data;
      }
    } catch (err) {
      AlertService.addErrorAlert("Update to Verification Group failed");
    }
  }


  checkSignatureComplete(student) {
    if (student.studentSignDate) {
      if (student.dependencyStatus === 0) {
        if (student.parentSignDate) {
          return true;
        }
      } else {
        return true;
      }
    }
    return false;
  }

  async getWorklist(worklistType, schoolCode) {
    try {
      const resp = await StudentAPI.get(
        `worklist/${worklistType}/${schoolCode}/${
          store.getState().global.aidYear
        }`
      );
      return resp.data;
    } catch (err) {
    }
  }

  async assignWorklistStudent(uuid, schoolCode) {
    try {
      const resp = await StudentAPI.post(
        `Student/AssignStudent/${schoolCode}/${uuid}`
      );
      if(!resp.data){
        AlertService.addErrorAlert("Unable to assign student");
      }
    } catch (err) {
    }
  }

  async AccessLogSearch(searchParameters) {
    try {
      const resp = await StudentAPI.post(
        `AccessLog/AccessLogSearch/`,
        searchParameters
      );
      return resp.data;
    } catch (err) {
    }
  }

  async SearchStudentStatusHistory(parameters) {
    try {
      const resp = await StudentAPI.post(
        "StudentStatusHistory/search",
        parameters
      );
      return resp.data;
    } catch (err) {
      return;
    }
  }

  getStudentHistoryByStudentID = async (studentID) => {
    try {
      const resp = await StudentAPI.get(
        "StudentHistory/getStudentHistoryByStudentID/" + studentID
      );
      return resp.data;
    } catch (err) {
    }
  };

  getStudentCorrectionHistoryByStudentID = async (studentID) => {
    try {
      const resp = await StudentAPI.get(
        "CorrectionHistory/getCorrectionHistoryByStudentID/" + studentID
      );
      return resp.data;
    } catch (err) {
    }
  };

  getStudentAccountHistoryByStudentID = async (studentID) => {
    try {
      const resp = await StudentAPI.get(
        "StudentAccountHistory/getStudentAccountHistoryByStudentID/" + studentID
      );
      return resp.data;
    } catch (err) {
    }
  };

  async VerifyAllInterviewLinks(parameters) {
    try {
      const resp = await StudentAPI.patch(
        "StudentInterviewLink/VerifyAll",
        parameters
      );
      return resp.data;
    } catch (err) {
      return false;
    }
  }

  async getStudentCommentCodeLinksByUUID(uuid) {
    try {
      const resp = await StudentAPI.get(
        `StudentCommentCodeLink/GetByUUID/${uuid}`
      );
      return resp.data;
    } catch (err) {
      return;
    }
  }

  async updateStudentCommentCodeLink(link) {
    try {
      const resp = await StudentAPI.patch(
        `StudentCommentCodeLink/${link.id}`,
        link
      );
      console.log(resp.data);
      return resp.data;
    } catch (err) {
      return false;
    }
  }

  async getAllCommentCodeInfo() {
    try {
      const resp = await StudentAPI.get(`commentCodeInfo`);
      return resp.data;
    } catch (err) {
      return;
    }
  }

  updateCommentCodes = async (commentCode, interviewTypeID) => {
    try {
      const resp = await StudentAPI.patch(
        `commentCodeInfo/updateByCode/${commentCode}/${interviewTypeID}`
      );
      return resp.data;
    } catch (err) {
    }
  };

  addStudentInterviewLinkMemo = async (memo) => {
    try {
      const resp = await StudentAPI.post(`StudentInterviewLinkMemo/`, memo);
      AlertService.addSuccessAlert("Successfully added task list memo");
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert("Task list memo add failed");
    }
  };

  deleteStudentInterviewLinkMemo = async (id) => {
    try {
      const resp = await StudentAPI.delete(`StudentInterviewLinkMemo/${id}`);
      AlertService.addSuccessAlert("Successfully deleted task list memo");
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert("Task list memo delete failed");
    }
  }

  updateStudentInterviewLinkMemo = async (memo) => {
    try {
      const resp = await StudentAPI.patch(`StudentInterviewLinkMemo/${memo.id}`, memo);
      AlertService.addSuccessAlert("Successfully updated task list memo");
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert("Task list memo update failed");
    }
  }

  searchStudentInterviewLinkMemo = async (searchParameters) => {
    try {
      const resp = await StudentAPI.post(`StudentInterviewLinkMemo/search`, searchParameters);
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert("Search for task list memos failed");
    }
  }

  getManyStudentInterviewLinkMemosByStudentID = async (studentID) => {
    try {
      const resp = await StudentAPI.get(
        `StudentInterviewLinkMemo/getManyStudentInterviewLinkMemosByStudentID/${studentID}`
      );
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert("Get many for task list memos failed");
    }
  };
  getCRCodeHeadlineStatusByStudentID = async (studentID) => {
    try {
      const resp = await StudentAPI.get(
        `StudentInterviewLink/GetCRCodeHeadlineStatusByStudentID/${studentID}`
      );
      return resp.data;
    } catch (err) {
    }
  };

  async searchStudentAccountLinks(studentAccountLink) {
    try {
      const resp = await StudentAPI.post(
        `StudentAccountLink/search/`,
        studentAccountLink
      );
      return resp.data;
    } catch (err) {
    }
  }

  async getManyStudentAccountLink(parameters) {
    try {
      const resp = await StudentAPI.post(
        `StudentAccountLink/getMany/`,
        parameters
      );
      return resp.data;
    } catch (err) {
    }
  }

  //AV Flow
  async getAllAutoVerifyFlow() {
    try {
      const resp = await StudentAPI.get("AutoVerifyFlow/");
      return resp.data;
    } catch (error) {}
  }

  async getOneAutoVerifyFlow(id) {
    try {
      const resp = await StudentAPI.get(`AutoVerifyFlow/${id}`);
      return resp.data;
    } catch (error) {}
  }

  async addAutoVerifyFlow(paramters) {
    try {
      const resp = await StudentAPI.post("AutoVerifyFlow/", paramters);
      AlertService.addSuccessAlert("Successfully added auto verify flow");
      return resp.data;
    } catch (error) {}
  }

  async updateAutoVerifyFlow(parameters) {
    try {
      const resp = await StudentAPI.patch(
        `AutoVerifyFlow/${parameters.id}`,
        parameters
      );
      AlertService.addSuccessAlert("Successfully updated auto verify flow");
      return resp.data;
    } catch (error) {}
  }

  async deleteAutoVerifyFlow(id) {
    try {
      const resp = await StudentAPI.delete(`AutoVerifyFlow/deleteFlow/${id}`);
      AlertService.addSuccessAlert("Successfully deleted auto verify flow");
      return resp.data;
    } catch (error) {}
  }

  //AV Section
  async getAllAutoVerifySection() {
    try {
      const resp = await StudentAPI.get("AutoVerifySection/");
      return resp.data;
    } catch (error) {}
  }

  async getOneAutoVerifySection(id) {
    try {
      const resp = await StudentAPI.get(`AutoVerifySection/${id}`);
      return resp.data;
    } catch (error) {}
  }

  async addAutoVerifySection(paramters) {
    try {
      const resp = await StudentAPI.post("AutoVerifySection/", paramters);
      AlertService.addSuccessAlert("Successfully added auto verify section");
      return resp.data;
    } catch (error) {}
  }

  async searchAutoVerifySection(paramters) {
    try {
      const resp = await StudentAPI.post("AutoVerifySection/search", paramters);
      return resp.data;
    } catch (error) {}
  }

  async updateAutoVerifySection(parameters) {
    try {
      const resp = await StudentAPI.patch(
        `AutoVerifySection/allowNullUpdate/${parameters.id}`,
        parameters
      );
      AlertService.addSuccessAlert("Successfully updated auto verify section");
      return resp.data;
    } catch (error) {}
  }

  async deleteAutoVerifySection(id) {
    try {
      const resp = await StudentAPI.delete(
        `AutoVerifySection/deleteSection/${id}`
      );
      AlertService.addSuccessAlert("Successfully deleted auto verify section");
      return resp.data;
    } catch (error) {
      AlertService.addErrorAlert("Unsuccessfully deleted auto verify section");
    }
  }

  //AV condition set
  async getAllAutoVerifyConditionSet() {
    try {
      const resp = await StudentAPI.get("AutoVerifyConditionSet/");
      return resp.data;
    } catch (error) {}
  }

  async getOneAutoVerifyConditionSet(id) {
    try {
      const resp = await StudentAPI.get(`AutoVerifyConditionSet/${id}`);
      return resp.data;
    } catch (error) {}
  }

  async addAutoVerifyConditionSet(paramters) {
    try {
      const resp = await StudentAPI.post("AutoVerifyConditionSet/", paramters);
      AlertService.addSuccessAlert(
        "Successfully added auto verify condition set"
      );
      return resp.data;
    } catch (error) {}
  }

  async updateAutoVerifyConditionSet(parameters) {
    try {
      const resp = await StudentAPI.patch(
        `AutoVerifyConditionSet/${parameters.id}`,
        parameters
      );
      AlertService.addSuccessAlert(
        "Successfully updated auto verify condition set"
      );
      return resp.data;
    } catch (error) {}
  }

  async deleteAutoVerifyConditionSet(id) {
    try {
      const resp = await StudentAPI.delete(
        `AutoVerifyConditionSet/deleteConditionSet/${id}`
      );
      AlertService.addSuccessAlert(
        "Successfully deleted auto verify condition set"
      );
      return resp.data;
    } catch (error) {}
  }

  //AV condition
  async getAllAutoVerifyCondition() {
    try {
      const resp = await StudentAPI.get("AutoVerifyCondition/");
      return resp.data;
    } catch (error) {}
  }

  async getOneAutoVerifyCondition(id) {
    try {
      const resp = await StudentAPI.get(`AutoVerifyCondition/${id}`);
      return resp.data;
    } catch (error) {}
  }

  async addAutoVerifyCondition(paramters) {
    try {
      const resp = await StudentAPI.post("AutoVerifyCondition/", paramters);
      AlertService.addSuccessAlert("Successfully added auto verify condition");
      return resp.data;
    } catch (error) {}
  }

  async updateAutoVerifyCondition(parameters) {
    try {
      const resp = await StudentAPI.patch(
        `AutoVerifyCondition/${parameters.id}`,
        parameters
      );
      AlertService.addSuccessAlert(
        "Successfully updated auto verify condition"
      );
      return resp.data;
    } catch (error) {}
  }

  async deleteAutoVerifyCondition(id) {
    try {
      const resp = await StudentAPI.delete(`AutoVerifyCondition/${id}`);
      AlertService.addSuccessAlert(
        "Successfully deleted auto verify condition"
      );
      return resp.data;
    } catch (error) {}
  }

  //AV evaluator
  async getAllAutoVerifyEvaluator() {
    try {
      const resp = await StudentAPI.get("AutoVerifyEvaluator/");
      return resp.data;
    } catch (error) {}
  }

  async getOneAutoVerifyEvaluator(id) {
    try {
      const resp = await StudentAPI.get(`AutoVerifyEvaluator/${id}`);
      return resp.data;
    } catch (error) {}
  }

  async addAutoVerifyEvaluator(paramters) {
    try {
      const resp = await StudentAPI.post("AutoVerifyEvaluator/", paramters);
      AlertService.addSuccessAlert("Successfully added auto verify evaluator");
      return resp.data;
    } catch (error) {}
  }

  async updateAutoVerifyEvaluator(parameters) {
    try {
      const resp = await StudentAPI.patch(
        `AutoVerifyEvaluator/${parameters.id}`,
        parameters
      );
      AlertService.addSuccessAlert(
        "Successfully updated auto verify evaluator"
      );
      return resp.data;
    } catch (error) {}
  }

  async deleteAutoVerifyEvaluator(id) {
    try {
      const resp = await StudentAPI.delete(`AutoVerifyEvaluator/${id}`);
      AlertService.addSuccessAlert(
        "Successfully deleted auto verify evaluator"
      );
      return resp.data;
    } catch (error) {}
  }

  //AV Component
  async getAllAutoVerifyComponent() {
    try {
      const resp = await StudentAPI.get("AutoVerifyComponent/");
      return resp.data;
    } catch (error) {}
  }

  async getOneAutoVerifyComponent(id) {
    try {
      const resp = await StudentAPI.get(`AutoVerifyComponent/${id}`);
      return resp.data;
    } catch (error) {}
  }

  async addAutoVerifyComponent(paramters) {
    try {
      const resp = await StudentAPI.post("AutoVerifyComponent/", paramters);
      AlertService.addSuccessAlert("Successfully added auto verify component");
      return resp.data;
    } catch (error) {}
  }

  async updateAutoVerifyComponent(parameters) {
    try {
      const resp = await StudentAPI.patch(
        `AutoVerifyComponent/${parameters.id}`,
        parameters
      );
      AlertService.addSuccessAlert(
        "Successfully updated auto verify component"
      );
      return resp.data;
    } catch (error) {}
  }

  async deleteAutoVerifyComponent(id) {
    try {
      const resp = await StudentAPI.delete(`AutoVerifyComponent/${id}`);
      AlertService.addSuccessAlert(
        "Successfully deleted auto verify component"
      );
      return resp.data;
    } catch (error) {}
  }

  //AV pseudo query
  async getAllAutoVerifyPseudoQuery() {
    try {
      const resp = await StudentAPI.get("AutoVerifyPseudoQuery/");
      return resp.data;
    } catch (error) {}
  }

  async getOneAutoVerifyPseudoQuery(id) {
    try {
      const resp = await StudentAPI.get(`AutoVerifyPseudoQuery/${id}`);
      return resp.data;
    } catch (error) {}
  }

  async addAutoVerifyPseudoQuery(paramters) {
    try {
      const resp = await StudentAPI.post("AutoVerifyPseudoQuery/", paramters);
      AlertService.addSuccessAlert(
        "Successfully added auto verify pseudo query"
      );
      return resp.data;
    } catch (error) {}
  }

  async updateAutoVerifyPseudoQuery(parameters) {
    try {
      const resp = await StudentAPI.patch(
        `AutoVerifyPseudoQuery/${parameters.id}`,
        parameters
      );
      AlertService.addSuccessAlert(
        "Successfully updated auto verify pseudo query"
      );
      return resp.data;
    } catch (error) {}
  }

  async deleteAutoVerifyPseudoQuery(id) {
    try {
      const resp = await StudentAPI.delete(`AutoVerifyPseudoQuery/${id}`);
      AlertService.addSuccessAlert(
        "Successfully deleted auto verify pseudo query"
      );
      return resp.data;
    } catch (error) {}
  }

  async getAutoVerifyPseudoQueryQueryObjects() {
    try {
      const resp = await StudentAPI.get("AutoVerifyPseudoQuery/QueryObjects");
      return resp.data;
    } catch (error) {}
  }

  //AV pseudo query filters
  async getAllAutoVerifyPseudoQueryFilter() {
    try {
      const resp = await StudentAPI.get("AutoVerifyPseudoQueryFilter/");
      return resp.data;
    } catch (error) {}
  }

  async getOneAutoVerifyPseudoQueryFilter(id) {
    try {
      const resp = await StudentAPI.get(`AutoVerifyPseudoQueryFilter/${id}`);
      return resp.data;
    } catch (error) {}
  }

  async addAutoVerifyPseudoQueryFilter(parameters) {
    try {
      const resp = await StudentAPI.post(
        "AutoVerifyPseudoQueryFilter/AddAutoVerifyPseudoQueryFilter/",
        parameters
      );
      AlertService.addSuccessAlert(
        "Successfully added auto verify pseudo query filter"
      );
      return resp.data;
    } catch (error) {}
  }

  async updateAutoVerifyPseudoQueryFilter(parameters) {
    try {
      const resp = await StudentAPI.patch(
        `AutoVerifyPseudoQueryFilter/UpdateAutoVerifyFilter/`,
        parameters
      );
      AlertService.addSuccessAlert(
        "Successfully updated auto verify pseudo query filter"
      );
      return resp.data;
    } catch (error) {}
  }

  async deleteAutoVerifyPseudoQueryFilter(id) {
    try {
      const resp = await StudentAPI.delete(`AutoVerifyPseudoQueryFilter/${id}`);
      AlertService.addSuccessAlert(
        "Successfully deleted auto verify pseudo query filter"
      );
      return resp.data;
    } catch (error) {}
  }

  //AV redirectGroup
  async getAllAutoVerifyRedirectGroup() {
    try {
      const resp = await StudentAPI.get("AutoVerifyRedirectGroup/");
      return resp.data;
    } catch (error) {}
  }

  async getOneAutoVerifyRedirectGroup(id) {
    try {
      const resp = await StudentAPI.get(`AutoVerifyRedirectGroup/${id}`);
      return resp.data;
    } catch (error) {}
  }

  async addAutoVerifyRedirectGroup(paramters) {
    try {
      const resp = await StudentAPI.post("AutoVerifyRedirectGroup/", paramters);
      AlertService.addSuccessAlert(
        "Successfully added auto verify redirect group"
      );
      return resp.data;
    } catch (error) {}
  }

  async updateAutoVerifyRedirectGroup(parameters) {
    try {
      const resp = await StudentAPI.patch(
        `AutoVerifyRedirectGroup/allowNullUpdate/${parameters.id}`,
        parameters
      );
      AlertService.addSuccessAlert(
        "Successfully updated auto verify redirect group"
      );
      return resp.data;
    } catch (error) {}
  }

  async deleteAutoVerifyRedirectGroup(id) {
    try {
      const resp = await StudentAPI.delete(
        `AutoVerifyRedirectGroup/deleteRedirectGroup/${id}`
      );
      AlertService.addSuccessAlert(
        "Successfully deleted auto verify redirect group"
      );
      return resp.data;
    } catch (error) {}
  }

  async getFullFlow(id) {
    try {
      const resp = await StudentAPI.get(`autoverify/GetFullFlow/${id}`);
      return resp.data;
    } catch (error) {}
  }

  //lock ISIR
  async lockStudentIsir(studentID, isirVersion, doLock) {
    try {
      const resp = await StudentAPI.post(
        `Student/LockStudentIsir/${studentID}/${isirVersion}/${doLock}`
      );
      return resp.data;
    } catch (err) {
    }
  }

  //delete owners
  async deleteOwners(studentIDs) {
    try {
      const resp = await StudentAPI.post("Student/DeleteOwners", studentIDs);
      return resp.data;
    } catch (err) {
    }
  }

  //mark postcards sent
  async markPostcardsSent(studentIDs) {
    try {
      const resp = await StudentAPI.post(
        `Student/MarkPostcardsSent/`,
        studentIDs
      );
      return resp.data;
    } catch (err) {
    }
  }

  getManyStudentInterviewLinkHistoryByStudentID = async (studentID) => {
    try {
      const resp = await StudentAPI.get(
        "StudentInterviewLinkHistory/getManyStudentInterviewLinkHistoryByStudentID/" +
          studentID
      );
      return resp.data;
    } catch (err) {
    }
  }
  
  reviewCompleted = async (studentID, alternativeVerifiedStatus) => {
    try {
      let url = "student/ReviewComplete/" + studentID;
      if(alternativeVerifiedStatus)
        url = url + "?altVerifiedStatus=" + alternativeVerifiedStatus;
      const resp = await StudentAPI.post(url);
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert(err.response.data);
      return false;
    }
  }

  getPovertyLevelsByAidYear = async aidYear => {
    try {
      const resp = await StudentAPI.get(
        "povertylevel/GetByAidYear/" + aidYear
      );
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert(err);
    }
  }

  getDownloadLogsByStudentID = async studentID => {
    try {
      const resp = await StudentAPI.post("documentDownloadLog/search/", {
        "studentID": studentID
      });
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert(err);
    }
  }

  updateConfirmedCorrectionAutoVerifyStatus = async (studentID, status) => {
    try {
      const resp = await StudentAPI.post(`student/updateConfirmedCorrectionAutoVerifyStatus/${studentID}/${status}`);
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert(err);
    }
  }
}


let instance = new StudentService();
export default instance;
